<script lang="ts" setup>
import type { Props } from './types'
withDefaults(defineProps<Props>(), {
  botPictureType: 'icon'
})
const { t } = useI18n()
</script>

<script lang="ts">
export default {
  name: 'AppChatBubbleAuthor'
}
</script>

<template>
  <span
    v-if="author === 'user'"
    class="app-chat__author-user-title">
    {{ t('you') }}
  </span>

  <div
    v-else
    class="app-chat__author-bot-title">
    <img
      src="https://assets.lahaus.com/static/images/pdp/SamPhoto.png?auto=compress,enhance,format"
      class="w-32 h-32 object-cover mr-8"
      alt="Sam">
  </div>
</template>

<i18n src="./i18n.json" lang="json" />
